import { useForm as useFormHook } from "hooks";
import { JsonableFields } from "consts/onboarding";
import {
    FormField,
    type OnboardingPaymentMethods,
    type OnboardingPaymentMethodsForm
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    methods = [],
    ...restInitialValues
}: Partial<OnboardingPaymentMethods>): OnboardingPaymentMethods => ({
    [FormField.Methods]: methods,
    [JsonableFields.RequestedChangeFields]: null,
    [JsonableFields.FieldsStatuses]: null,
    [JsonableFields.FieldsComments]: null,
    ...restInitialValues
});

export const useForm = (onboardingPaymentMethods: OnboardingPaymentMethodsForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingPaymentMethods,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
